import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { APP_VERSION } from './version';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // كسر تخزين المتصفّح/الخادم المؤقّت المؤقّتيّ (CDN) لملفّات locales — عنوانها ثابت بين
      // الإصدارات (بخلاف حزم JS المُصدَّرة بأسماء تتضمّن hash)، فيبقى المتصفّح/الخادم الوسيط
      // يُقدِّم نسخة قديمة إلى الأبد حتى بعد نشر إصدار جديد يضيف مفاتيح جديدة — أُلاحظ هذا
      // بالضبط: مفاتيح pricingMode/medicationPricePolicy الجديدة ظهرت خامّة/بالعربي رغم
      // اختيار الإنجليزية، لأنّ locales/en/translation.json المُخزَّن كان أقدم من الكود الفعليّ.
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${APP_VERSION}`,
    },
  });

export default i18n;
